import type { WorktreeBaseBranches } from '@buildautomaton/types';
import { getBridgeRoot } from '../../files/cwd/index.js';
import type { LogFn } from '../../log.js';
import { prepareNewSessionWorktrees } from '../prepare-new-session-worktrees.js';
import type { WorktreeLayoutFile } from '../worktree-layout-file.js';
import type { SessionWorktreeCache } from './session-worktree-cache.js';

export async function prepareAndRememberSessionWorktrees(params: {
  cache: SessionWorktreeCache;
  sessionId: string;
  worktreesRootPath: string;
  layout: WorktreeLayoutFile;
  log: LogFn;
  worktreeBaseBranches?: WorktreeBaseBranches;
}): Promise<string | undefined> {
  const prep = await prepareNewSessionWorktrees({
    worktreesRootPath: params.worktreesRootPath,
    bridgeRoot: getBridgeRoot(),
    sessionId: params.sessionId,
    layout: params.layout,
    log: params.log,
    ...(params.worktreeBaseBranches && Object.keys(params.worktreeBaseBranches).length > 0
      ? { worktreeBaseBranches: params.worktreeBaseBranches }
      : {}),
  });
  if (!prep) return undefined;
  params.cache.remember(params.sessionId, {
    sessionParentPath: prep.sessionParentPath,
    repoCheckoutPaths: prep.worktreePaths,
  });
  return params.cache.getSessionParentPath(params.sessionId);
}
